import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../SharedComponents";

interface IIllHealthProps extends IProcessComponentProps {
    data: DrawdownModel;
    getDrawdownModel: VoidFunction;
}

interface IIllHealthState {
    showDetail: boolean;
}

export class IllHealth extends ProcessComponent<IIllHealthProps, IIllHealthState> {
    constructor(props: any) {
        super(props);
        this.state = { showDetail: false };
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        return (
            <>
                {SectionHeader("Are you proceeding on the basis of ill health?")}
                <RadiosEditor
                    label="As the client is below the minimum retirement age, this process can only be completed if you are proceeding on the basis of ill health. Please confirm if this is the case."
                    options={[true, false]}
                    getText={(o) => (o ? "Yes" : "No")}
                    onChange={(v) => {
                        onChange({ IllHealth: v });
                        if (v) {this.props.getDrawdownModel();}
                    }}
                    cssWrapper="rg-inline mb-10"
                    required="Please select"
                    selected={data?.InstructionId == null ? false : true}
                />
            </>
        );
    }
}
